export const TEXTS = {
    ADD_MONEY_PAGE_TITLE: "Add Balance",
};

export const SWIGGY_PAY_PAYMENT_CODE = "SwiggyPay";

export const AMOUNT_SELECTION_TYPE = {
    PREDEFINED: "PREDEFINED",
    CUSTOM: "CUSTOM",
};
